/* eslint-disable no-useless-escape */
import { notification } from 'antd';
var ie = require('inscricaoestadual');

const openNotification = (msg: string, dica: string) => {
  notification.error({
    message: msg,
    description: dica,
    placement: 'bottomRight',
  });
};

export function cpfValidation(cpf: any) {
  if (typeof cpf !== 'string') return false;

  cpf = cpf.replace(/[^\d]+/g, '');

  if (cpf.length !== 11) {
    openNotification('CPF inválido', 'Verifique a quantidade de dígitos');
    return false;
  } else if (!!cpf.match(/(\d)\1{10}/)) {
    openNotification('CPF inválido', 'Esse é um formato inválido');
    return false;
  }

  // String para Array
  cpf = cpf.split('');

  const validator = cpf
    // Pegar os últimos 2 digitos de validação
    .filter((digit: any, index: any, array: []) => index >= array.length - 2 && digit)
    // Transformar digitos em números
    .map((el: any) => +el);

  const toValidate = (pop: any) =>
    cpf
      // Pegar Array de items para validar
      .filter((digit: any, index: any, array: []) => index < array.length - pop && digit)
      // Transformar digitos em números
      .map((el: any) => +el);

  const rest = (count: any, pop: any) =>
    ((toValidate(pop)
      // Calcular Soma dos digitos e multiplicar por 10
      .reduce((soma: any, el: any, i: any) => soma + el * (count - i), 0) *
      10) %
      // Pegar o resto por 11
      11) %
    // transformar de 10 para 0
    10;
  if (!(rest(10, 2) !== validator[0] || rest(11, 1) !== validator[1])) {
    return true;
  }

  openNotification('CPF inválido', 'Por favor insira um CPF válido');
  return !(rest(10, 2) !== validator[0] || rest(11, 1) !== validator[1]) ? true : false;
}

export function cnpjValidation(value: any) {
  if (!value) return false;

  if (value.length > 18) {
    openNotification('CNPJ inválido', 'Verifique a quantidade de dígitos');
    return false;
  }

  if (value.replace(/\.|\-|\//g, '').length !== 14) {
    openNotification('CNPJ inválido', 'Verifique a quantidade de dígitos ou o formato');
    return false;
  }

  // Guarda um array com todos os dígitos do valor
  const match = value.toString().match(/\d/g);
  const numbers = Array.isArray(match) ? match.map(Number) : [];

  // Elimina inválidos com todos os dígitos iguais
  const items = [...new Set(numbers)];
  if (items.length === 1) {
    openNotification('CNPJ inválido', 'Esse é um formato inválido');
    return false;
  }

  // Cálculo validador
  const calc = (x: any) => {
    const slice = numbers.slice(0, x);
    let factor = x - 7;
    let sum = 0;

    for (let i = x; i >= 1; i--) {
      const n = slice[x - i];
      sum += n * factor--;
      if (factor < 2) factor = 9;
    }
    const result = 11 - (sum % 11);
    return result > 9 ? 0 : result;
  };

  // Separa os 2 últimos dígitos de verificadores
  const digits = numbers.slice(12);
  // Valida 1o. dígito verificador
  const digit0 = calc(12);
  const digit1 = calc(13);

  // Valida 2o. dígito verificador
  if (digit0 !== digits[0] || digit1 !== digits[1]) {
    openNotification('CNPJ inválido', 'Informe um CNPJ válido.');
    return false;
  }
  return digit1 === digits[1];
}

export function ieValidation(inscricao: string, estado: string) {
  return ie(inscricao, estado);
}

export const ieValidator = (ie: string, uf: string) => {
  const ieClean = ie?.replace(/\D/g, '');
  const ufClean = uf?.trim();

  const length = ieClean?.length;
  switch (length) {
    case 14:
      return ['RO'].includes(ufClean);
    case 13:
      return ['AC', 'DF', 'MG'].includes(ufClean);
    case 12:
      return ['SP'].includes(ufClean);
    case 11:
      return ['MT', 'TO'].includes(ufClean);
    case 10:
      return ['AL', 'PR', 'RS'].includes(ufClean);
    case 9:
      return [
        'AP',
        'AM',
        'BA',
        'CE',
        'ES',
        'GO',
        'MA',
        'MS',
        'PA',
        'PB',
        'PE',
        'PI',
        'RN',
        'RR',
        'SC',
        'SE',
        'MT',
        'TO',
      ].includes(ufClean);
    case 8:
      return ['RJ'].includes(ufClean);
    default:
      return false;
  }
};

export function placaValidation(placa: string): boolean {
  const regex = /^[A-Z]{3}\d{1}(\d|[A-Z])\d{2}$/;
  return regex.test(placa);
}

export function phoneValidation(telefone: string): boolean {
  const regex = /^\(\d{2}\)\s\d{4,5}-\d{4}$/;
  return regex.test(telefone);
}
